<template>
  <div class="seg-content general user">
    <div class="mob-nav" :class="{open: menuOpen}">
      <div class="mn-handle"><a href="" v-on:click.prevent="toggleMenu"><span></span></a></div>
      <div class="mobn-main">
        <div class="search">
          <form>
            <input type="text" placeholder="Search anything!" />
          </form>
        </div>
        <ul>
          <li v-for="(menuItem, mi) in menuItems" :class="{open: menuSubOpen===mi}">
            <a :href="menuItem.link" v-on:click="openSubMenu($event, mi)">{{ menuItem.title }}</a>
            <ul>
              <li v-for="(menuItem2, mi2) in menuItem.sub || []" :class="{dw: menuItem2.mode=='dw'}">
                <a :href="menuItem2.link">{{ menuItem2.title }}</a>
                <ul v-if="menuItem2.mode=='dw'">
                  <li>
                    <div class="menu-subt">{{ menuItem2.col1.title }}</div>
                    <ul>
                      <li v-for="(menuItem3, mi3) in menuItem2.col1.sub"><a :href="menuItem3.link">{{ menuItem3.title }}</a></li>
                    </ul>
                  </li>
                  <li>
                    <div class="menu-subt">{{ menuItem2.col2.title }}</div>
                    <ul>
                      <li v-for="(menuItem3, mi3) in menuItem2.col2.sub"><a :href="menuItem3.link">{{ menuItem3.title }}</a></li>
                    </ul>
                  </li>
                </ul>
                <ul v-else>
                  <li v-for="(menuItem3, mi3) in menuItem2.sub"><a :href="menuItem3.link">{{ menuItem3.title }}</a></li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    
    <section class="home-list" v-if="false">
      <div class="hl-wid ww1 transparent"></div>
      <div class="hl-wid ww2">
        <div class="multitab-widget">
          <ul class="mttabs">
            <li class="active"><a href="">Login</a></li>
            <li class=""><a href="">Create Account</a></li>
          </ul>
          <ul class="mttabc">
            <li class="active">
              <form class="user-form login">
                <div class="uf-row split">
                  <div>
                    <label>Username</label>
                    <input type="text" />
                  </div>
                  <div>
                    <label>Password</label>
                    <input type="password" />
                  </div>
                </div>
                <div class="uf-row to-r">
                  <a href="" class="forgot">Forgot password ?</a>
                </div>
                <div class="uf-row">
                  <label class="check">
                    <input type="checkbox"></input>
                    <i></i>
                    <span>Remember me</span>
                  </label>
                </div>
                <div class="uf-row to-c">
                  <button class="main">Login</button>
                </div>
              </form>
            </li>
            <li class="active">
              <form class="user-form login">
                <div class="uf-row split">
                  <div>
                    <label>Username</label>
                    <input type="text" />
                  </div>
                  <div>
                    <label>Email Address</label>
                    <input type="email" />
                  </div>
                </div>
                <div class="uf-row split">
                  <div>
                    <label>First Name</label>
                    <input type="text" />
                  </div>
                  <div>
                    <label>Last Name</label>
                    <input type="text" />
                  </div>
                </div>
                <div class="uf-row split">
                  <div>
                    <label>Password</label>
                    <input type="password" />
                  </div>
                  <div>
                    <label>Confirm Password</label>
                    <input type="password" />
                  </div>
                </div>
                <div class="uf-row">
                  <label class="check">
                    <input type="checkbox"></input>
                    <i></i>
                    <span>I agree to <a href="">terms</a> and <a href="">privacy policy</a></span>
                  </label>
                </div>
                <div class="uf-row to-c">
                  <button class="main">Create Account</button>
                </div>
              </form>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="home-list" v-if="false">
      <nav class="main-nav wh2 ww1">
        <div class="search">
          <form>
            <input type="text" placeholder="Search anything!" />
          </form>
        </div>
        <ul>
          <li>
            <a href="">Home</a>
          </li>
          <li>
            <a href="">Classes</a>
            <ul>
              <a href="" class="toggle"></a>
              <li class="dw">
                <a href="">Group Classes</a>
                <ul>
                  <li>
                    <div class="menu-subt">Matwork</div>
                    <ul>
                      <li><a href="">Beginner</a></li>
                      <li><a href="">Intermediate</a></li>
                      <li><a href="">Advanced</a></li>
                      <li><a href="">Traditional / Classical work</a></li>
                    </ul>
                  </li>
                  <li>
                    <div class="menu-subt">Small Equipment Apparatus</div>
                    <ul>
                      <li><a href="">Beginner</a></li>
                      <li><a href="">Intermediate</a></li>
                      <li><a href="">Advanced</a></li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <a href="">Private Classes</a>
                <ul>
                  <li><a href="">Beginner</a></li>
                  <li><a href="">Intermediate</a></li>
                  <li><a href="">Advanced</a></li>
                  <li><a href="">Sports Specific</a></li>
                  <li><a href="">Needs Specific</a></li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <a href="">Tutorials</a>
            <ul>
              <a href="" class="toggle"></a>
              <li>
                <a href="">REPERTOIRE</a>
                <ul>
                  <li><a href="">Matwork</a></li>
                  <li><a href="">Reformer work</a></li>
                  <li><a href="">Cadillac work</a></li>
                  <li><a href="">Chair work</a></li>
                  <li><a href="">Ladder Barrel work</a></li>
                  <li><a href="">Spine Corrector work</a></li>
                  <li><a href="">Ped-O-Pull work</a></li>
                  <li><a href="">Small Equipement work</a></li>
                </ul>
              </li>
              <li>
                <a href="">PEOPLE'S NEEDS</a>
                <ul>
                  <li><a href="">Breathing</a></li>
                  <li><a href="">Alignement</a></li>
                  <li><a href="">Set Ups</a></li>
                  <li><a href="">Core / Abdominals</a></li>
                  <li><a href="">Spine / Back</a></li>
                  <li><a href="">Head / Neck</a></li>
                  <li><a href="">Shoulders</a></li>
                  <li><a href="">Thorax / Ribcage</a></li>
                  <li><a href="">Pelvis / Sacrum</a></li>
                  <li><a href="">Legs / Knees</a></li>
                  <li><a href="">Ankle / Foot</a></li>
                  <li><a href="">Arms / Hand</a></li>
                </ul>
              </li>
              <li>
                <a href="">WORKSHOPS</a>
                <ul>
                  <li><a href="">Master Teachers</a></li>
                  <li><a href="">Lolita San Miguel</a></li>
                  <li><a href="">Mary Bowen</a></li>
                  <li><a href="">Kathy Corey</a></li>
                  <li><a href="">Brett Howard</a></li>
                  <li><a href="">Blossom Crawford</a></li>
                  <li><a href="">Ton &amp; Michael</a></li>
                  <li><a href="">Madeline Black</a></li>
                  <li><a href="">Iva Mazzoleni</a></li>
                  <li><a href="">Katya Smirnova</a></li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <a href="">Archival</a>
          </li>
          <li>
            <a href="">Discussions</a>
          </li>
          <li>
            <a href="">Articles</a>
          </li>
        </ul>
      </nav>
      <div class="hl-wid ww2 wh2 ubox">
        <div class="ub-head">
          <h2>Notifications</h2>
          <span class="ubh-ico notify hn"></span>
        </div>
        <ul class="unotlist">
          <li class="message">
            <i></i>
            <div class="upic"><img src="temp/user1.jpg" /></div>
            <div class="un-cont">
              <div class="user">Ivan Ivanovic</div>
              <div class="unc">Hello Elisabet, I've seen your last message...</div>
            </div>
            <time>2 hours ago</time>
          </li>
          <li class="like">
            <i></i>
            <div class="upic"><img src="temp/user2.jpg" /></div>
            <div class="un-cont">
              <div class="user">Katia Hammouche</div>
              <div class="unc">Katia liked your post</div>
            </div>
            <time>3 hours ago</time>
          </li>
          <li class="fav">
            <i></i>
            <div class="upic"><img src="temp/user3.jpg" /></div>
            <div class="un-cont">
              <div class="user">Myriam Piccard</div>
              <div class="unc">Myriam set your playlist as favorite</div>
            </div>
            <time>4 hours ago</time>
          </li>
          <li class="notify">
            <i></i>
            <div class="upic"><img src="temp/user4.jpg" /></div>
            <div class="un-cont">
              <div class="user">Iva Mazzoleni</div>
              <div class="unc">Pilates Vision Info Board</div>
            </div>
            <time>1 day ago</time>
          </li>
        </ul>
        <div class="un-lm"><a href="">Show more</a></div>
      </div>
      <div class="hl-wid ww1 wh2 ubox">
        <div class="ub-head">
          <h2>Payments</h2>
          <span class="ubh-ico cart"></span>
        </div>
        <div class="ub-payment">
          <div class="time-rem">
            <svg viewbox="0 0 160 160" width="160" height="160">
              <circle cx="80" cy="80" r="78" style="stroke: #ccc; stroke-width:4; fill: transparent" />
              <path style="stroke:rgb(255,0,0);stroke-width:4; fill: transparent" :d="'M 80 2 A 78 78 0 '+(expiryPeriodPercent>50?'1':'0')+' 1 '+(80+Math.cos((90-expiryPeriodPercent*3.6)/180*3.14159265)*78)+' '+(80-Math.sin((90-expiryPeriodPercent*3.6)/180*3.14159265)*78)" />
            </svg>
            <span>{{ expiryPeriodPercent }}<em>%</em></span>
          </div>
          <div class="time-left">
            <span>Time Left</span>
            276 days of 365
          </div>
        </div>
        <div class="ubp-foot">
          <time>September 27th, 2020</time>
        </div>
      </div>
    </section>
    
    <section class="home-list" v-if="false">
      <nav class="main-nav wh2 ww1">
        <div class="search">
          <form>
            <input type="text" placeholder="Search anything!" />
          </form>
        </div>
        <ul>
          <li>
            <a href="">Home</a>
          </li>
          <li>
            <a href="">Classes</a>
            <ul>
              <a href="" class="toggle"></a>
              <li class="dw">
                <a href="">Group Classes</a>
                <ul>
                  <li>
                    <div class="menu-subt">Matwork</div>
                    <ul>
                      <li><a href="">Beginner</a></li>
                      <li><a href="">Intermediate</a></li>
                      <li><a href="">Advanced</a></li>
                      <li><a href="">Traditional / Classical work</a></li>
                    </ul>
                  </li>
                  <li>
                    <div class="menu-subt">Small Equipment Apparatus</div>
                    <ul>
                      <li><a href="">Beginner</a></li>
                      <li><a href="">Intermediate</a></li>
                      <li><a href="">Advanced</a></li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <a href="">Private Classes</a>
                <ul>
                  <li><a href="">Beginner</a></li>
                  <li><a href="">Intermediate</a></li>
                  <li><a href="">Advanced</a></li>
                  <li><a href="">Sports Specific</a></li>
                  <li><a href="">Needs Specific</a></li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <a href="">Tutorials</a>
            <ul>
              <a href="" class="toggle"></a>
              <li>
                <a href="">REPERTOIRE</a>
                <ul>
                  <li><a href="">Matwork</a></li>
                  <li><a href="">Reformer work</a></li>
                  <li><a href="">Cadillac work</a></li>
                  <li><a href="">Chair work</a></li>
                  <li><a href="">Ladder Barrel work</a></li>
                  <li><a href="">Spine Corrector work</a></li>
                  <li><a href="">Ped-O-Pull work</a></li>
                  <li><a href="">Small Equipement work</a></li>
                </ul>
              </li>
              <li>
                <a href="">PEOPLE'S NEEDS</a>
                <ul>
                  <li><a href="">Breathing</a></li>
                  <li><a href="">Alignement</a></li>
                  <li><a href="">Set Ups</a></li>
                  <li><a href="">Core / Abdominals</a></li>
                  <li><a href="">Spine / Back</a></li>
                  <li><a href="">Head / Neck</a></li>
                  <li><a href="">Shoulders</a></li>
                  <li><a href="">Thorax / Ribcage</a></li>
                  <li><a href="">Pelvis / Sacrum</a></li>
                  <li><a href="">Legs / Knees</a></li>
                  <li><a href="">Ankle / Foot</a></li>
                  <li><a href="">Arms / Hand</a></li>
                </ul>
              </li>
              <li>
                <a href="">WORKSHOPS</a>
                <ul>
                  <li><a href="">Master Teachers</a></li>
                  <li><a href="">Lolita San Miguel</a></li>
                  <li><a href="">Mary Bowen</a></li>
                  <li><a href="">Kathy Corey</a></li>
                  <li><a href="">Brett Howard</a></li>
                  <li><a href="">Blossom Crawford</a></li>
                  <li><a href="">Ton &amp; Michael</a></li>
                  <li><a href="">Madeline Black</a></li>
                  <li><a href="">Iva Mazzoleni</a></li>
                  <li><a href="">Katya Smirnova</a></li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <a href="">Archival</a>
          </li>
          <li>
            <a href="">Discussions</a>
          </li>
          <li>
            <a href="">Articles</a>
          </li>
        </ul>
      </nav>
      <div class="hl-wid ww2 wh2 ubox">
        <div class="ub-head mb">
          <h2>Account Information</h2>
          <span class="ubh-ico user"></span>
        </div>
        <form class="user-form login">
          <div class="uf-row split">
            <div>
              <label>Username</label>
              <input type="text" />
            </div>
            <div>
              <label>Email Address</label>
              <input type="email" />
            </div>
          </div>
          <div class="uf-row split">
            <div>
              <label>First Name</label>
              <input type="text" />
            </div>
            <div>
              <label>Last Name</label>
              <input type="text" />
            </div>
          </div>
          <div class="uf-row split">
            <div>
              <label>Password</label>
              <input type="password" />
            </div>
            <div>
              <label>Confirm Password</label>
              <input type="password" />
            </div>
          </div>
          <!--<div class="uf-row">
            <label class="check">
              <input type="checkbox"></input>
              <i></i>
              <span>I agree to <a href="">terms</a> and <a href="">privacy policy</a></span>
            </label>
          </div>-->
          <div class="uf-row to-c">
            <button class="main">Update</button>
          </div>
        </form>
      </div>
      <div class="hl-wid ww1 wh2 ubox">
        <div class="ub-head mb">
          <h2>Email Preferences</h2>
          <span class="ubh-ico notify"></span>
        </div>
        <form class="user-form lspc">
          <div class="uf-row">
            <label class="check">
              <input type="checkbox"></input>
              <i></i>
              <span>News and updates</a></span>
            </label>
          </div>
          <div class="uf-row">
            <label class="check">
              <input type="checkbox"></input>
              <i></i>
              <span>When I get a new private message</a></span>
            </label>
          </div>
          <div class="uf-row">
            <label class="check">
              <input type="checkbox"></input>
              <i></i>
              <span>When there is a new Playlist or Video for a Program that I follow</a></span>
            </label>
          </div>
          <div class="uf-row">
            <label class="check">
              <input type="checkbox"></input>
              <i></i>
              <span>When there is a new comment in a thread that I follow</a></span>
            </label>
          </div>
          <div class="uf-row">
            <label class="check">
              <input type="checkbox"></input>
              <i></i>
              <span>When there are new videos by teachers I follow</a></span>
            </label>
          </div>
          <div class="uf-row to-c">
            <button class="main">Update</button>
          </div>
        </form>
        
      </div>
      <div class="hl-wid ww4 wh2 ubox">
        <div class="ub-head mb">
          <h2>Public Profile</h2>
          <span class="ubh-ico user"></span>
        </div>
        <form class="user-form">
          <div class="uf-row split4">
            <div>
              <label>Public Name<em>*</em></label>
              <input type="text" />
            </div>
            <div>
              <label>My Gender<em>*</em></label>
              <div class="select">
                <span>Female</span>
                <select>
                  <option>Male</option>
                  <option>Female</option>
                  <option>Other</option>
                </select>
              </div>
            </div>
            <div>
              <label>My Location<em>*</em></label>
              <input type="text" />
            </div>
            <div>
              <label>Years of Pilates Experience</label>
              <div class="select">
                <span>16</span>
                <select>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                </select>
              </div>
            </div>
          </div>
          <div class="uf-row split4">
            <div>
              <label>About Me</label>
              <textarea></textarea>
            </div>
            <div>
              <label>Profile Image</label>
              <div class="pimg-wid">
                <div class="pimg-con">
                  <img src="temp/user.jpg" />
                  <a href=""></a>
                </div>
                <div class="pimg-note">
                  Click on image to edit your public appereance
                </div>
              </div>
            </div>
            <div>
              <div class="uf-row">
                <label>My Birthday</label>
                <input type="text" />
              </div>
              <div class="uf-row">
                <label class="check">
                  <input type="checkbox"></input>
                  <i></i>
                  <span>Show my age on profile</a></span>
                </label>
              </div>
              <div class="uf-row to-c">
                <button class="sec">Profile Preview</button>
              </div>
            </div>
            <div>
              <div class="uf-row">
                <label>Practice Frequency</label>
                <div class="select">
                  <span>Twice a week</span>
                  <select>
                    <option>Daily</option>
                    <option>Twice a week</option>
                    <option>Weekly</option>
                  </select>
                </div>
              </div>
              <div class="uf-row">
                <label class="check">
                  <input type="checkbox"></input>
                  <i></i>
                  <span>I'm a Teacher</a></span>
                </label>
              </div>
              <div class="uf-row">
                <label class="check">
                  <input type="checkbox"></input>
                  <i></i>
                  <span>I'm a Studio Owner</a></span>
                </label>
              </div>
              <div class="uf-row to-c">
                <button class="main">Update</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
    
    <section v-if="false" class="home-list">
      <nav class="main-nav wh2 ww1">
        <div class="search">
          <form>
            <input type="text" placeholder="Search anything!" />
          </form>
        </div>
        <ul>
          <li>
            <a href="">Home</a>
          </li>
          <li>
            <a href="">Classes</a>
            <ul>
              <a href="" class="toggle"></a>
              <li class="dw">
                <a href="">Group Classes</a>
                <ul>
                  <li>
                    <div class="menu-subt">Matwork</div>
                    <ul>
                      <li><a href="">Beginner</a></li>
                      <li><a href="">Intermediate</a></li>
                      <li><a href="">Advanced</a></li>
                      <li><a href="">Traditional / Classical work</a></li>
                    </ul>
                  </li>
                  <li>
                    <div class="menu-subt">Small Equipment Apparatus</div>
                    <ul>
                      <li><a href="">Beginner</a></li>
                      <li><a href="">Intermediate</a></li>
                      <li><a href="">Advanced</a></li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <a href="">Private Classes</a>
                <ul>
                  <li><a href="">Beginner</a></li>
                  <li><a href="">Intermediate</a></li>
                  <li><a href="">Advanced</a></li>
                  <li><a href="">Sports Specific</a></li>
                  <li><a href="">Needs Specific</a></li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <a href="">Tutorials</a>
            <ul>
              <a href="" class="toggle"></a>
              <li>
                <a href="">REPERTOIRE</a>
                <ul>
                  <li><a href="">Matwork</a></li>
                  <li><a href="">Reformer work</a></li>
                  <li><a href="">Cadillac work</a></li>
                  <li><a href="">Chair work</a></li>
                  <li><a href="">Ladder Barrel work</a></li>
                  <li><a href="">Spine Corrector work</a></li>
                  <li><a href="">Ped-O-Pull work</a></li>
                  <li><a href="">Small Equipement work</a></li>
                </ul>
              </li>
              <li>
                <a href="">PEOPLE'S NEEDS</a>
                <ul>
                  <li><a href="">Breathing</a></li>
                  <li><a href="">Alignement</a></li>
                  <li><a href="">Set Ups</a></li>
                  <li><a href="">Core / Abdominals</a></li>
                  <li><a href="">Spine / Back</a></li>
                  <li><a href="">Head / Neck</a></li>
                  <li><a href="">Shoulders</a></li>
                  <li><a href="">Thorax / Ribcage</a></li>
                  <li><a href="">Pelvis / Sacrum</a></li>
                  <li><a href="">Legs / Knees</a></li>
                  <li><a href="">Ankle / Foot</a></li>
                  <li><a href="">Arms / Hand</a></li>
                </ul>
              </li>
              <li>
                <a href="">WORKSHOPS</a>
                <ul>
                  <li><a href="">Master Teachers</a></li>
                  <li><a href="">Lolita San Miguel</a></li>
                  <li><a href="">Mary Bowen</a></li>
                  <li><a href="">Kathy Corey</a></li>
                  <li><a href="">Brett Howard</a></li>
                  <li><a href="">Blossom Crawford</a></li>
                  <li><a href="">Ton &amp; Michael</a></li>
                  <li><a href="">Madeline Black</a></li>
                  <li><a href="">Iva Mazzoleni</a></li>
                  <li><a href="">Katya Smirnova</a></li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <a href="">Archival</a>
          </li>
          <li>
            <a href="">Discussions</a>
          </li>
          <li>
            <a href="">Articles</a>
          </li>
        </ul>
      </nav>
      <div class="hl-wid ww1 wh2 wt1">
        <span class="category">Lifestyle</span>
        <h2>Made in USA: Pilates as Drive-in Style</h2>
        <div class="img"><img src="temp/wid1.jpg" /><a class="play" href=""></a></div>
        <div class="intro">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it 2000 years old.</div>
        <div class="author"><img src="temp/person.jpg" />Ivan Ivanovic</div>
        <date>13 Sep 2019</date>
        <div class="comments">23</div>
        <div class="favs">108</div>
        <a class="share">Share</a>
        <a class="more" href="">Learn more</a>
        <a class="wlink" href="" v-on:click.prevent="$router.push({name: 'content'})"></a>
      </div>
      <div class="hl-wid ww1 wh2 wt2">
        <span class="category">Lifestyle</span>
        <h2>Made in USA: Pilates as Drive-in Style</h2>
        <div class="img"><img src="temp/wid1.jpg" /><a class="play" href=""></a></div>
        <div class="intro">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it 2000 years old.</div>
        <div class="author"><img src="temp/person.jpg" />Ivan Ivanovic</div>
        <date>13 Sep 2019</date>
        <div class="comments">23</div>
        <div class="favs">108</div>
        <a class="share">Share</a>
        <a class="more" href="">Learn more</a>
        <a class="wlink" href="" v-on:click.prevent="$router.push({name: 'content'})"></a>
      </div>
      <div class="hl-list">
        <h2>Very Latest</h2>
        <ul class="latest">
          <li>
            <span class="category">Tutorials</span>
            <h2><a href="">SETUP YOUR REFORMER MACHINERY AND RUN</a></h2>
            <date>1 hour ago</date>
          </li>
          <li>
            <span class="category">Tutorials</span>
            <h2><a href="">SETUP YOUR REFORMER MACHINERY AND RUN</a></h2>
            <date>1 hour ago</date>
          </li>
          <li>
            <span class="category">Tutorials</span>
            <h2><a href="">SETUP YOUR REFORMER MACHINERY AND RUN</a></h2>
            <date>1 hour ago</date>
          </li>
          <li>
            <span class="category">Tutorials</span>
            <h2><a href="">SETUP YOUR REFORMER MACHINERY AND RUN</a></h2>
            <date>1 hour ago</date>
          </li>
          <li>
            <span class="category">Tutorials</span>
            <h2><a href="">SETUP YOUR REFORMER MACHINERY AND RUN</a></h2>
            <date>1 hour ago</date>
          </li>
        </ul>
      </div>
      <div class="hl-wid ww2 wh1 wt3">
        <span class="category">Lifestyle</span>
        <h2>Made in USA: Pilates as Drive-in Style</h2>
        <div class="img"><img src="temp/wid1.jpg" /><a class="play" href=""></a></div>
        <div class="intro">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it 2000 years old.</div>
        <div class="author"><img src="temp/person.jpg" />Ivan Ivanovic</div>
        <date>13 Sep 2019</date>
        <div class="comments">23</div>
        <div class="favs">108</div>
        <a class="share">Share</a>
        <a class="more" href="">Learn more</a>
        <a class="wlink" href="" v-on:click.prevent="$router.push({name: 'content'})"></a>
      </div>
      <div class="hl-wid ww1 wh2 wtad1">
        <span class="category">Commercial</span>
        <h2>Isn't Supprising that your's one is just there?</h2>
        <div class="img"><img src="temp/apadbg.jpg" /><a class="play" href=""></a></div>
        <span class="adlogo"></span>
        <a class="more" href="">Ask Apple where?!</a>
        <a class="wlink" href="" v-on:click.prevent="$router.push({name: 'content'})"></a>
      </div>
      <div class="hl-wid ww2 wh2 wt4">
        <span class="category">Lifestyle</span>
        <h2>Made in USA: Pilates as Drive-in Style</h2>
        <div class="img"><img src="temp/wid1.jpg" /><a class="play" href=""></a></div>
        <div class="intro">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it 2000 years old.</div>
        <div class="author"><img src="temp/person.jpg" />Ivan Ivanovic</div>
        <date>13 Sep 2019</date>
        <div class="comments">23</div>
        <div class="favs">108</div>
        <a class="share" href="">Share</a>
        <a class="more" href="">Learn more</a>
        <a class="wlink" href="" v-on:click.prevent="$router.push({name: 'content'})"></a>
      </div>
      <div class="hl-wid ww2 wh1 wt5">
        <span class="category">Lifestyle</span>
        <h2>Made in USA: Pilates as Drive-in Style</h2>
        <div class="img"><img src="temp/wid1.jpg" /><a class="play" href=""></a></div>
        <div class="intro">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it 2000 years old.</div>
        <div class="author"><img src="temp/person.jpg" />Ivan Ivanovic</div>
        <date>13 Sep 2019</date>
        <div class="comments">23</div>
        <div class="favs">108</div>
        <a class="share">12</a>
        <a class="more" href="">Learn more</a>
        <a class="wlink" href="" v-on:click.prevent="$router.push({name: 'content'})"></a>
      </div>
      <div class="hl-wid ww2 wh2 wt6">
        <span class="category">Lifestyle</span>
        <h2>Made in USA: Pilates as Drive-in Style</h2>
        <div class="img"><img src="temp/wid1.jpg" /><a class="play" href=""></a></div>
        <div class="intro">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it 2000 years old.</div>
        <div class="author"><img src="temp/person.jpg" />Ivan Ivanovic</div>
        <date>13 Sep 2019</date>
        <div class="comments">23</div>
        <div class="favs">108</div>
        <a class="share">12</a>
        <a class="more" href="">Learn more</a>
        <a class="wlink" href="" v-on:click.prevent="$router.push({name: 'content'})"></a>
      </div>
      <div class="hl-wid ww2 wh2 wt7">
        <span class="category">Lifestyle</span>
        <h2>Made in USA: Pilates as Drive-in Style</h2>
        <div class="img"><img src="temp/wid1.jpg" /><a class="play" href=""></a></div>
        <div class="intro">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it 2000 years old.</div>
        <div class="author"><img src="temp/person.jpg" />Ivan Ivanovic</div>
        <date>13 Sep 2019</date>
        <div class="comments">23</div>
        <div class="favs">108</div>
        <a class="share">12</a>
        <a class="more" href="">Learn more</a>
        <a class="wlink" href="" v-on:click.prevent="$router.push({name: 'content'})"></a>
      </div>
      <div class="hl-wid hl-prof ww1 wh2">
        <span class="category">Teacher of the week</span>
        <div class="pimg"><img src="temp/person.jpg" /></div>
        <div class="hlp-sum">
          <div class="favs">108</div>
          <div class="comments">23</div>
        </div>
        <span class="name">Iva <br />Mazzoleni</span>
        <span class="role">Pilates educator</span>
      </div>
      <div class="hl-wid ww3 wh2 wt8">
        <span class="category">Lifestyle</span>
        <h2>Made in USA: Pilates as Drive-in Style</h2>
        <div class="img"><img src="temp/wid1.jpg" /><a class="play" href=""></a></div>
        <div class="intro">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it 2000 years old.</div>
        <div class="author"><img src="temp/person.jpg" />Ivan Ivanovic</div>
        <date>13 Sep 2019</date>
        <div class="comments">23</div>
        <div class="favs">108</div>
        <a class="share">12</a>
        <a class="more" href="">Learn more</a>
        <a class="wlink" href="" v-on:click.prevent="$router.push({name: 'content'})"></a>
      </div>
      
      <div class="hl-list">
        <h2>Top comments</h2>
        <ul class="latest">
          <li>
            <div class="author"><img src="temp/person.jpg" />Ivan Ivanovic</div>
            <div class="intro">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it 2000 years old.</div>
            <date>1 hour ago</date>
            <div class="comments">22</div>
          </li>
          <li>
            <div class="author"><img src="temp/person.jpg" />Ivan Ivanovic</div>
            <div class="intro">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it 2000 years old.</div>
            <date>1 hour ago</date>
            <div class="comments">22</div>
          </li>
          <li>
            <div class="author"><img src="temp/person.jpg" />Ivan Ivanovic</div>
            <div class="intro">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it 2000 years old.</div>
            <date>1 hour ago</date>
            <div class="comments">22</div>
          </li>
          <li>
            <div class="author"><img src="temp/person.jpg" />Ivan Ivanovic</div>
            <div class="intro">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it 2000 years old.</div>
            <date>1 hour ago</date>
            <div class="comments">22</div>
          </li>
        </ul>
      </div>
      
      <div class="hl-wid ww2 wh2 wt9">
        <span class="category">Lifestyle</span>
        <h2>Made in USA: Pilates as Drive-in Style</h2>
        <div class="img"><img src="temp/wid1.jpg" /><a class="play" href=""></a></div>
        <div class="intro">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it 2000 years old.</div>
        <div class="author"><img src="temp/person.jpg" />Ivan Ivanovic</div>
        <date>13 Sep 2019</date>
        <div class="comments">23</div>
        <div class="favs">108</div>
        <a class="share">12</a>
        <a class="more" href="">Learn more</a>
        <a class="wlink" href="" v-on:click.prevent="$router.push({name: 'content'})"></a>
      </div>
      <div class="hl-wid ww1 wh2 wt10">
        <span class="category">Lifestyle</span>
        <h2>Made in USA: Pilates as Drive-in Style</h2>
        <div class="img"><img src="temp/wid1.jpg" /><a class="play" href=""></a></div>
        <div class="intro">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it 2000 years old.</div>
        <div class="author"><img src="temp/person.jpg" />Ivan Ivanovic</div>
        <date>13 Sep 2019</date>
        <div class="comments">23</div>
        <div class="favs">108</div>
        <a class="share">12</a>
        <a class="more" href="">Learn more</a>
        <a class="wlink" href="" v-on:click.prevent="$router.push({name: 'content'})"></a>
      </div>
      <div class="hl-wid ww1_5 wh2 wt11">
        <span class="category">Lifestyle</span>
        <h2>Made in USA: Pilates as Drive-in Style</h2>
        <div class="img"><img src="temp/wid1.jpg" /><a class="play" href=""></a></div>
        <div class="intro">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it 2000 years old.</div>
        <div class="author"><img src="temp/person.jpg" />Ivan Ivanovic</div>
        <date>13 Sep 2019</date>
        <div class="comments">23</div>
        <div class="favs">108</div>
        <a class="share">12</a>
        <a class="more" href="">Learn more</a>
        <a class="wlink" href="" v-on:click.prevent="$router.push({name: 'content'})"></a>
      </div>
      <div class="hl-wid ww1_5 wh2 wt12">
        <span class="category">Lifestyle</span>
        <h2>Made in USA: Pilates as Drive-in Style</h2>
        <div class="img"><img src="temp/wid1.jpg" /><a class="play" href=""></a></div>
        <div class="intro">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it 2000 years old.</div>
        <div class="author"><img src="temp/person.jpg" />Ivan Ivanovic</div>
        <date>13 Sep 2019</date>
        <div class="comments">23</div>
        <div class="favs">108</div>
        <a class="share">12</a>
        <a class="more" href="">Learn more</a>
        <a class="wlink" href="" v-on:click.prevent="$router.push({name: 'content'})"></a>
      </div>
      <!--<div class="hl-wid wh2">
        2 <br /> blabla
      </div>
      <div class="hl-wid ww1 wh2">
        3
      </div>
      <div class="hl-wid ww1">
        4 <br /> a <br /> blabla
      </div>
      <div class="hl-wid ww1">
        5
      </div>
      <div class="hl-wid ww1">
       6 <br /> a
      </div>-->
    </section>
<!--     POST LIST -->
    
    <section class="home-list">
      <nav class="main-nav wh2 ww1">
        <div class="search">
          <form>
            <input type="text" placeholder="Search anything!" />
          </form>
        </div>
        <ul>
          <li>
            <a href="">Home</a>
          </li>
          <li>
            <a href="">Classes</a>
            <ul>
              <a href="" class="toggle"></a>
              <li class="dw">
                <a href="">Group Classes</a>
                <ul>
                  <li>
                    <div class="menu-subt">Matwork</div>
                    <ul>
                      <li><a href="">Beginner</a></li>
                      <li><a href="">Intermediate</a></li>
                      <li><a href="">Advanced</a></li>
                      <li><a href="">Traditional / Classical work</a></li>
                    </ul>
                  </li>
                  <li>
                    <div class="menu-subt">Small Equipment Apparatus</div>
                    <ul>
                      <li><a href="">Beginner</a></li>
                      <li><a href="">Intermediate</a></li>
                      <li><a href="">Advanced</a></li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <a href="">Private Classes</a>
                <ul>
                  <li><a href="">Beginner</a></li>
                  <li><a href="">Intermediate</a></li>
                  <li><a href="">Advanced</a></li>
                  <li><a href="">Sports Specific</a></li>
                  <li><a href="">Needs Specific</a></li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <a href="">Tutorials</a>
            <ul>
              <a href="" class="toggle"></a>
              <li>
                <a href="">REPERTOIRE</a>
                <ul>
                  <li><a href="">Matwork</a></li>
                  <li><a href="">Reformer work</a></li>
                  <li><a href="">Cadillac work</a></li>
                  <li><a href="">Chair work</a></li>
                  <li><a href="">Ladder Barrel work</a></li>
                  <li><a href="">Spine Corrector work</a></li>
                  <li><a href="">Ped-O-Pull work</a></li>
                  <li><a href="">Small Equipement work</a></li>
                </ul>
              </li>
              <li>
                <a href="">PEOPLE'S NEEDS</a>
                <ul>
                  <li><a href="">Breathing</a></li>
                  <li><a href="">Alignement</a></li>
                  <li><a href="">Set Ups</a></li>
                  <li><a href="">Core / Abdominals</a></li>
                  <li><a href="">Spine / Back</a></li>
                  <li><a href="">Head / Neck</a></li>
                  <li><a href="">Shoulders</a></li>
                  <li><a href="">Thorax / Ribcage</a></li>
                  <li><a href="">Pelvis / Sacrum</a></li>
                  <li><a href="">Legs / Knees</a></li>
                  <li><a href="">Ankle / Foot</a></li>
                  <li><a href="">Arms / Hand</a></li>
                </ul>
              </li>
              <li>
                <a href="">WORKSHOPS</a>
                <ul>
                  <li><a href="">Master Teachers</a></li>
                  <li><a href="">Lolita San Miguel</a></li>
                  <li><a href="">Mary Bowen</a></li>
                  <li><a href="">Kathy Corey</a></li>
                  <li><a href="">Brett Howard</a></li>
                  <li><a href="">Blossom Crawford</a></li>
                  <li><a href="">Ton &amp; Michael</a></li>
                  <li><a href="">Madeline Black</a></li>
                  <li><a href="">Iva Mazzoleni</a></li>
                  <li><a href="">Katya Smirnova</a></li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <a href="">Archival</a>
          </li>
          <li>
            <a href="">Discussions</a>
          </li>
          <li>
            <a href="">Articles</a>
          </li>
        </ul>
        <div class="search sear-ext">
          <form>
            <input type="text" placeholder="Search anything!" />
          </form>
        </div>
      </nav>
      <div class="hl-wid ww3 adm-list">
        <ul class="tab-like">
          <li class="head">
            <ul>
              <li class="title">
                <span>Title</span>
                <a href="" class="s-inc"></a>
                <a href="" class="s-dec active"></a>
              </li>
              <li class="type">
                <span>Type</span>
                <a href="" class="s-inc"></a>
                <a href="" class="s-dec"></a>
              </li>
              <li class="author">
                <span>Author</span>
                <a href="" class="s-inc"></a>
                <a href="" class="s-dec"></a>
              </li>
              <li class="date">
                <span>Date</span>
                <a href="" class="s-inc"></a>
                <a href="" class="s-dec"></a>
              </li>
            </ul>
          </li>
          <li>
            <ul>
              <li class="title"><a href="">Pilates Reformer Video</a></li>
              <li class="type">Class</li>
              <li class="author">Iva Mazzoieni</li>
              <li class="date">January 24, 2020</li>
              <li class="remove"><a href="">remove</a></li>
            </ul>
          </li>
          <li>
            <ul>
              <li class="title"><a href="">Matwork</a></li>
              <li class="type">Workshop</li>
              <li class="author">Igor Trifunovic</li>
              <li class="date">February 24, 2019</li>
              <li class="remove"><a href="">remove</a></li>
            </ul>
          </li>
          <li>
            <ul>
              <li class="title"><a href="">Pilates Style</a></li>
              <li class="type">Workshop</li>
              <li class="author">Iva Mazzoieni</li>
              <li class="date">January 24, 2020</li>
              <li class="remove"><a href="">remove</a></li>
            </ul>
          </li>
          <li>
            <ul>
              <li class="title"><a href="">Pilates Reformer Video</a></li>
              <li class="type">Class</li>
              <li class="author">Iva Mazzoieni</li>
              <li class="date">January 24, 2020</li>
              <li class="remove"><a href="">remove</a></li>
            </ul>
          </li>
          <li>
            <ul>
              <li class="title"><a href="">Matwork</a></li>
              <li class="type">Workshop</li>
              <li class="author">Igor Trifunovic</li>
              <li class="date">February 24, 2019</li>
              <li class="remove"><a href="">remove</a></li>
            </ul>
          </li>
          <li>
            <ul>
              <li class="title"><a href="">Pilates Style</a></li>
              <li class="type">Workshop</li>
              <li class="author">Iva Mazzoieni</li>
              <li class="date">January 24, 2020</li>
              <li class="remove"><a href="">remove</a></li>
            </ul>
          </li>
          <li>
            <ul>
              <li class="title"><a href="">Pilates Reformer Video</a></li>
              <li class="type">Class</li>
              <li class="author">Iva Mazzoieni</li>
              <li class="date">January 24, 2020</li>
              <li class="remove"><a href="">remove</a></li>
            </ul>
          </li>
          <li>
            <ul>
              <li class="title"><a href="">Matwork</a></li>
              <li class="type">Workshop</li>
              <li class="author">Igor Trifunovic</li>
              <li class="date">February 24, 2019</li>
              <li class="remove"><a href="">remove</a></li>
            </ul>
          </li>
          <li>
            <ul>
              <li class="title"><a href="">Pilates Style</a></li>
              <li class="type">Workshop</li>
              <li class="author">Iva Mazzoieni</li>
              <li class="date">January 24, 2020</li>
              <li class="remove"><a href="">remove</a></li>
            </ul>
          </li>
          <li>
            <ul>
              <li class="title"><a href="">Pilates Reformer Video</a></li>
              <li class="type">Class</li>
              <li class="author">Iva Mazzoieni</li>
              <li class="date">January 24, 2020</li>
              <li class="remove"><a href="">remove</a></li>
            </ul>
          </li>
          <li>
            <ul>
              <li class="title"><a href="">Matwork</a></li>
              <li class="type">Workshop</li>
              <li class="author">Igor Trifunovic</li>
              <li class="date">February 24, 2019</li>
              <li class="remove"><a href="">remove</a></li>
            </ul>
          </li>
          <li>
            <ul>
              <li class="title"><a href="">Pilates Style</a></li>
              <li class="type">Workshop</li>
              <li class="author">Iva Mazzoieni</li>
              <li class="date">January 24, 2020</li>
              <li class="remove"><a href="">remove</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </section>
    
    

    
  </div>
</template>
<script>
export default {
  data: ()=>({
    expiryPeriodPercent: 25,
  }),
}
</script>
